import { JsonApiModelConfig, JsonApiModel, Attribute, HasMany, BelongsTo } from 'angular2-jsonapi';
import {Address} from "./address";
import {Site} from "./site";
import {Appointment} from "./appointment";
import {PageMetaData} from "./PageMetaData";


@JsonApiModelConfig({
  type: 'customer',
  meta: PageMetaData
})
export class Customer extends JsonApiModel {

  @Attribute()
  name: string;

  @HasMany()
  sites: Site[] = [];

}




// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/customer.ts